import { compareStr } from '@/plugins/utils'

export default {
  primesConfigs: (state) => state.configs,
  primeConfigByYear: (state) => (annee) =>
    state.configs &&
    state.configs.find((model) => compareStr(model.getAnnee())(annee)),
  primesConfigs_pending: (state) => state.configs_pending
}
